import { Component, OnInit } from '@angular/core';
import { ApiService, DatastoreService, CommonFunctionsService, NotificationStoreService } from 'src/app/services/index'
import { Router } from '@angular/router';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';

@Component({
  selector: 'app-member-bar',
  templateUrl: './member-bar.component.html',
  styleUrls: ['./member-bar.component.scss']
})
export class MemberBarComponent implements OnInit {
  constructor(
    private apiService: ApiService,
    public dataStore: DatastoreService,
    private notifStore: NotificationStoreService,
    private router: Router,
    private commonFunctionsService: CommonFunctionsService,
    private authService: MsalService
  ) { }
  member: any;
  rout: any;

  ngOnInit(): void {
    this.member = this.dataStore.loginObject.member;
    this.rout = this.router
    this.notifStore.sessionUpdate.subscribe(() => {
      console.log(this.dataStore.loginObject.member.first_name)
      this.member = this.dataStore.loginObject.member;
    })
  }

  goTo(page: String) {
    this.commonFunctionsService.newBooking();
    this.router.navigate([`${this.commonFunctionsService.getCompanyName()}/${this.commonFunctionsService.getCompanyId()}/${page}`]);
  }

  signOut() {
    this.dataStore.loggedIn = false;
    this.dataStore.client = undefined;
    
    if (this.dataStore.loggedInBySSO) {
      localStorage.clear();
      sessionStorage.clear();
      this.dataStore.authToken = null;
      this.dataStore.member = null;
      this.dataStore.member = null;
      this.dataStore.loginObject = null;
      this.dataStore.loggedIn = false;
      this.dataStore.loggedInBySSO = false;
      this.authService.logoutRedirect();
    }
    else {
      this.commonFunctionsService.logout();
    }
  }

}
